"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepInitValueFromConfigIfNoValue = void 0;
var makeArrayFromLength_1 = require("../../../utils/makeArrayFromLength");
var genHash_1 = require("./genHash");
var prepInitValueFromConfigIfNoValue = function (_a) {
    var _b, _c, _d;
    var _value = _a._value, config = _a.config, defaultColWidth = _a.defaultColWidth;
    //if colHeaderData is defined then that decides the noOfCols.
    var noOfCols = ((_b = config.colHeaderData) === null || _b === void 0 ? void 0 : _b.length) || config.noOfCols;
    var noOfRows = ((_c = config.rowHeaderData) === null || _c === void 0 ? void 0 : _c.length) || config.noOfRows;
    var value = ((_d = _value === null || _value === void 0 ? void 0 : _value.data) === null || _d === void 0 ? void 0 : _d.length) > 0 //value exists in the correct shape
        ? _value
        : Array.isArray(_value) && _value.length > 0 //value exists but in deprecated shape
            ? {
                data: _value,
                colWidthConfig: getInitColWidthConfigs({
                    noOfCols: _value[0].cellData.length,
                    defaultColWidth: defaultColWidth,
                }),
            } //backwards compat
            : {
                data: __spreadArray([], insertRowCellIdsAndComp({
                    noOfRows: noOfRows,
                    noOfCols: noOfCols,
                    blockConfig: config.blockConfig
                }), true),
                colWidthConfig: getInitColWidthConfigs({ noOfCols: noOfCols, defaultColWidth: defaultColWidth }),
            };
    return {
        value: value,
        enableColActions: config.colHeaderData ? false : true, // meaning if config.colHeaderData is defined, then no actions are possible on col
        enableRowActions: config.rowHeaderData ? false : true, // meaning if config.rowHeaderData is defined, then no actions are possible on row
        canToggleColHeaderStyle: !!!config.colHeaderData, // meaning its true if no config.colHeaderData is defined. else false
    };
};
exports.prepInitValueFromConfigIfNoValue = prepInitValueFromConfigIfNoValue;
var getInitColWidthConfigs = function (_a) {
    var noOfCols = _a.noOfCols, defaultColWidth = _a.defaultColWidth;
    return (0, makeArrayFromLength_1.makeArrayFromLength)(noOfCols)
        .map(function (d, i) { return ({
        colId: "col_".concat(i),
        width: defaultColWidth + "px",
    }); })
        .reduce(function (a, b) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[b.colId] = b.width, _a)));
    }, {});
};
var insertRowCellIdsAndComp = function (_a) {
    var noOfRows = _a.noOfRows, noOfCols = _a.noOfCols, _b = _a.blockConfig, blockConfig = _b === void 0 ? [] : _b;
    return (0, makeArrayFromLength_1.makeArrayFromLength)(noOfRows).map(function () { return ({
        id: "row_".concat((0, genHash_1.genHash)(8)),
        cellData: (0, makeArrayFromLength_1.makeArrayFromLength)(noOfCols).map(function (d, i) {
            var _a;
            return (__assign({ id: "cell_".concat((0, genHash_1.genHash)(8)) }, (((_a = blockConfig[i]) === null || _a === void 0 ? void 0 : _a.comp) ? { comp: blockConfig[i].comp, props: blockConfig[i].props || {} } : {})));
        }),
    }); });
};
